import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import sidebar from "./modules/sidebar";
import header from "./modules/header";
import footer from "./modules/footer";
import auth from "./modules/auth";
import setting from "./modules/setting";
import translation from "./modules/translation";
import theme from "./modules/theme";
import template from "@/store/modules/template";
import template_size from "@/store/modules/template_size";
import order from "@/store/modules/order";
import payment from "@/store/modules/payment";
import themes from "@/store/modules/themes";
import users from "@/store/modules/users";
import tags from "@/store/modules/tags";
import bundle from "@/store/modules/bundle";
import template_type from "@/store/modules/template_type";
import custom_design from "@/store/modules/custom_design";
import font from "./modules/font";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters,
    mutations,
    actions,
    modules: {
        bundle,
        users,
        themes,
        payment,
        order,
        template_size,
        template,
        auth,
        setting,
        tags,
        font,
        template_type,
        custom_design,
        navigations: {
            namespaced: true,
            modules: {
                header,
                sidebar,
                footer,
            },
        },
        scheme: {
            namespaced: true,
            modules: {
                theme,
            },
        },
        translation,
    },
});
